export default __webpack_public_path__ + "img/YsTWZhlg.dd81b44a.svg";